var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-modal__overlay",on:{"click":function () { return this$1.$emit('close'); }}},[_c('div',{staticClass:"b-modal__modal",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }